import React, { useEffect, useState } from "react";
import { Dialog, toastMessage } from "../utils";
import { useCustomizeTripWorkflowMutation, useGetTripcheckpointMutation } from "../../api/vmsSlice";
import GenericWorkflowUpdate from "../utils/GenericWorkflowUpdate";

const CustomizeTripWorkflow = ({ open, onClose, detailData }) => {
    const [tripData, setTripData]=useState()
	const [workflowData, setWorkflowData] = useState([]);
	const [getTripcheckpointTrigger] = useGetTripcheckpointMutation();
	const [updateCustomizeTripWorkflow]= useCustomizeTripWorkflowMutation()
	let tripId;

	if (detailData) {
		tripId = detailData?._id;
	}
	useEffect(() => {
		if (tripId) {
			getTripcheckpointTrigger({ type: "all", tripId: tripId })
				.then((res) => {
					// console.log('detail-chk', res.data);
					if (res?.error) {
						toastMessage(false, res.message);
					} else {
						setTripData(res?.data?.data || []);
						// console.log("workflowData", tripData);
					}
				})
				.catch((err) => {
					console.log("err", err);
				});
		}
	}, []);
	const handleSubmit = async () => {
			const payload={
				vehicleEntryId:tripId,
				checkpoints: workflowData
			}
			// console.log("Payload", payload)
			await updateCustomizeTripWorkflow(payload)
				.unwrap()
				.then((res) => {
					if (res.error == true) {
						toastMessage(false, res.message);
					} else {
						toastMessage(true, res.message);
						onClose()
					}
				})
				.catch((err) => {
					toastMessage(false, err.message);
				});
		};
	return (
		<>
			<Dialog
				size="lg"
				open={true}
				handleSubmit={handleSubmit}
				handleClose={() => {
					// setLabelDetail(labelData);
					onClose();
				}}
				handleCancel={() => onClose()}
				title={"Customize Trip Workflow"}
				SubmitText={"Update"}
			>
                <GenericWorkflowUpdate
					tripData={tripData}
					workflowData={workflowData}
					setWorkflowData={setWorkflowData}

                />
			</Dialog>
		</>
	);
};

export default CustomizeTripWorkflow;
